import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Anchor from 'common-ui-components/dist/components/Atoms/Anchor';
import { getLabelWithComponent } from '../../../utils/utils';

const TermsConditions = ({
  termsConditions,
  termsOfUseLink,
  termsOfUse,
  termsOfSaleLink,
  termsOfSale,
  watersPrivacyNoticeLink,
  watersPrivacyNotice,
  target,
}) => {
  const getLink = () => {
    const link = [];
    if (!isEmpty(termsOfUse)) {
      link.push(
        <Anchor target={target} key="1" to={termsOfUseLink} elementLocator="link-terms-of-user">
          {termsOfUse}
        </Anchor>
      );
    }
    if (!isEmpty(termsOfSale)) {
      link.push(
        <Anchor target={target} key="2" to={termsOfSaleLink} elementLocator="link-terms-of-sale">
          {termsOfSale}
        </Anchor>
      );
    }
    if (!isEmpty(watersPrivacyNotice)) {
      link.push(
        <Anchor
          target={target}
          key="3"
          to={watersPrivacyNoticeLink}
          elementLocator="link-waters-privacy-notice"
        >
          {watersPrivacyNotice}
        </Anchor>
      );
    }
    return link;
  };
  const result = getLabelWithComponent(termsConditions, getLink());

  return (
    <div className="termsConditions" data-locator="checkout-terms-conditions">
      {result.map(item => {
        if (typeof item === 'string') {
          return <span key={item}>{item}</span>;
        }
        return item;
      })}
    </div>
  );
};

TermsConditions.propTypes = {
  termsConditions: PropTypes.string,
  termsOfUseLink: PropTypes.string,
  termsOfUse: PropTypes.string,
  termsOfSaleLink: PropTypes.string,
  termsOfSale: PropTypes.string,
  watersPrivacyNoticeLink: PropTypes.string,
  watersPrivacyNotice: PropTypes.string,
  target: PropTypes.string,
};

TermsConditions.defaultProps = {
  termsConditions: '',
  termsOfUseLink: '',
  termsOfUse: '',
  termsOfSaleLink: '',
  termsOfSale: '',
  watersPrivacyNoticeLink: '',
  watersPrivacyNotice: '',
  target: '_blank',
};

export default TermsConditions;
